import React, { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Card, CardBody, Col, Row } from "reactstrap";
// Pages Components
import Miniwidget from "./Miniwidget";
//import MonthlyEarnings from "./montly-earnings";
import EmailSent from "./email-sent";
import MonthlyEarnings2 from "./montly-earnings2";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { Delete, MoreVert } from "@mui/icons-material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getItemPOList } from "../../api";
import { AmountCell } from "../../components/CustomComponents/AmountCell";
import useAuth from "../../hooks/useAuth";
import { getClientWithIdReq } from "../../service/clientService";
import { getPrFavoritesListReq, getPurchaseRequisitionListReq, removeFromFavouriteReq } from "../../service/purchaseRequisitionService";
import { getPurchaseOrderListReq } from "../../service/purchaseService";
import { MODULES_ENUM, PERMISSIONS_ENUM, USER_TYPES_ENUM } from "../../utility/constants";
import { formatDate } from "../../utility/formatDate";
import { formatNumberWithCommasAndDecimal } from "../Invoices/invoiceUtil";
import OrderStatusRenderer from "../Orders/OrderStatusRenderer";
import OrderGraph from "./order-graph";
import "./styles/Dashboard.scss";
import { useTransition } from "react";
import DateFilter from "../../components/CustomComponents/DateFilter";
import { getOrdersReq } from "../../service/orderService";
// import AgreementPdfComponent from "./AgreementPdfComponent";

const Dashboard = (props) => {
  document.title = "Willsmeet Portal";
  let navigate = useNavigate();


  const breadcrumbItems = [{ title: "Dashboard", link: "#" }];
     //fetch user from local
  const user = JSON.parse(localStorage.getItem("user"))
  const userType = user?.userType;
  const [inputValue, setInputValue] = useState('');
  const [rowData, setRowData] = useState([]);
  const [chipData, setChipData] = useState([
    {
      title: 'Total Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Total Purchase Orders',
      total: 0,
    },
    {
      title: 'Pending Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Pending Purchase Orders',
      total: 0,
    },
    {
      title: 'Approved Purchase Requisitions',
      total: 0,
    },
    {
      title: 'Approved Purchase Orders',
      total: 0,
    },
  ]);
 
     
  const getDefaultYearDateRange = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    start.setHours(0, 0, 0, 0);

    const end = new Date(now);
    end.setHours(23, 59, 59, 999);

    return {
      start: start.toISOString(),
      end: end.toISOString(),
    };
  };
  const { auth } = useAuth();
  const [clientData, setClientData] = useState({});
  const [topItems, setTopItems] = useState([]);
  const [topItemsLoading, setTopItemsLoading] = useState(false);
  const [favourites, setFavourites] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const defaultDateRange = useRef(getDefaultYearDateRange())
  const [date, setDate] = useState(() => defaultDateRange.current)
  const skipDateEffect = useRef(true)

  const toggleOptionsMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const handleDeleteFromFavorites = async (orderId) => {
    try {
      setOpenMenuId(null);
      const response = await removeFromFavouriteReq(orderId);

      if (response?.success === true) {
        setFavourites(prevFavourites =>
          prevFavourites.filter(item => item?.purchaseOrder?._id !== orderId)
        );
        notify('Success', "Removed from favorites");
      } else {
        notify('Error', 'Failed to remove from favorites');
      }
    } catch (error) {
      console.error("Error removing from favorites:", error);
      notify('Error', 'Failed to remove from favorites');
    }
  };




  const redirectToViewPage = (id) => {
    let path = `/purchase-orders/${id}`;
    setTimeout(() => {
      navigate(path, id);
    }, 300);
  };

  const handleViewClick = (id) => {
    redirectToViewPage(id.order_id);
  };

  const handleDeleteResponse = (response) => {
    if (response.success === true) {
      notify('Success', response.message);
    } else {
      notify('Error', response.message);
    }
    getPurchaseOrderListData();
  };

  const redirectToEditPage = (id) => {
    let path = `/purchase-orders/${id.order_id}/edit`;
    setTimeout(() => {
      navigate(path);
    }, 300);
  };

  const handleEditClick = (id) => {
    redirectToEditPage(id);
  };

  const notify = (type, message) => {
    if (type === 'Error') {
      toast.error(message, {
        position: 'top-center',
        theme: 'colored',
      });
    } else {
      toast.success(message, {
        position: 'top-center',
        theme: 'colored',
      });
    }
  };

  const getMonthName = (monthIndex) => {
    const months = [
      'January', 'February', 'March', 'April',
      'May', 'June', 'July', 'August',
      'September', 'October', 'November', 'December'
    ];
    return months[monthIndex];
  }

  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  }
  //filter the data based on dates
  const filterByDate = (data) => {
    return data.filter(item => {
      const created = new Date(item.createdAt || item.
        created_time)
      return (
        created >= new Date(date.start) &&
        created <= new Date(date.end)
      );
    });
  };

  const ordinalFormatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const monthName = getMonthName(date.getMonth());
    const ordinalDay = getOrdinal(date.getDate());

    return `${ordinalDay} ${monthName} ${year}`;
  };

  const getPurchaseOrderStatusList = async () => {
    try {
      //getting the po&pr data 
      const poList = await getPurchaseOrderListReq();
      const prList = await getPurchaseRequisitionListReq();
      const ongoingList = await getOrdersReq({
        page: 1,
        limit: 200
      });


      const ongoingData = Array.isArray(ongoingList) ? ongoingList : [];



      //applyn the filter for po&pl
      const filteredPO = filterByDate(poList.data);
      const filteredPR = filterByDate(prList.data);
      const filterOngoing = filterByDate(ongoingData)

      //related count of PR
      const totalPR = filteredPR.length;
      const approvedPR = filteredPR.filter(pr => pr.PRStatus === "approved").length;
      const pendingPR = filteredPR.filter(
        pr => ['draft', 'published'].includes(pr.PRStatus?.toLowerCase())).length;

      //related count of PO
      const totalPO = filteredPO.length;
      const approvedPOA = filteredPO.filter(po => po.POStatus === "accepted").length
      const approvedPOC = filteredPO.filter(po => po.POStatus === "approved").length;
      const pendingPOC = filteredPO.filter(
        po => ['draft', 'published'].includes(po.POStatus?.toLowerCase())).length;
      const pendingPOA = filteredPO.filter(po => po.POStatus === "sent").length

      //total count of Ongoing orders
      const totalOngoing = filterOngoing.length
      const pendingOG = filterOngoing.filter(o => ['draft', 'open'].includes((o?.order_status || '').toLowerCase())).length;
      const completedOG = filterOngoing.filter(o => ['closed'].includes((o?.order_status || '').toLowerCase())).length;

     

      const startDate = encodeURIComponent(date.start);
      const endDate = encodeURIComponent(date.end);

      const isAdmin = userType === "admin";
      const isClient = userType === "client";

      setChipData([
        isAdmin
          ? {
            title:"Total Ongoing Orders",
            total: totalOngoing,
            link: `/ongoing-orders?status=draft,open,closed&startDate=${startDate}&endDate=${endDate}`,
          }
          : {
            title: "Total Purchase Requisitions",
            total: totalPR,
            link: `/reports/customer-pr?startDate=${startDate}&endDate=${endDate}`,
          },

        {
          title: "Total Purchase Orders",
          total: totalPO,
          link: isAdmin
            ? `/reports/by-po?status=declined,sent,accepted&startDate=${startDate}&endDate=${endDate}`
            : `/reports/customer-po?startDate=${startDate}&endDate=${endDate}`,
        },

        isClient
          ? {
            title: "Pending Purchase Requisitions",
            total: pendingPR,
            link: `/reports/customer-pr?status=published,draft&startDate=${startDate}&endDate=${endDate}`,
          }
          : {
            title:"Pending Ongoing Orders",
            total: pendingOG,
            link: `/ongoing-orders?status=draft,open&startDate=${startDate}&endDate=${endDate}`,
          },

        {
          title: "Pending Purchase Orders",
          total: isAdmin ? pendingPOA : pendingPOC,
          link: isAdmin
            ? `/reports/by-po?status=sent&startDate=${startDate}&endDate=${endDate}`
            : `/reports/customer-po?status=published,draft&startDate=${startDate}&endDate=${endDate}`,
        },

        isClient
          ? {
            title: "Approved Purchase Requisitions",
            total: approvedPR,
            link: `/reports/customer-pr?status=approved&startDate=${startDate}&endDate=${endDate}`,
          }
          : {
            title:"Completed Ongoing Orders",
            total: completedOG,
            link: `/ongoing-orders?status=closed&startDate=${startDate}&endDate=${endDate}`,
          },

        {
          title: "Approved Purchase Orders",
          total: isAdmin ? approvedPOA : approvedPOC,
          link: isAdmin
            ? `/reports/by-po?status=accepted&startDate=${startDate}&endDate=${endDate}`
            : `/reports/customer-po?status=approved&startDate=${startDate}&endDate=${endDate}`,
        },
      ]);
    } catch (error) {
      console.error("Error:", error);
    }
  };


  const searchClient = async (id) => {
    try {
      const data = { _id: id };
      const res = await getClientWithIdReq(data);

      setClientData(res.payload?.client);
    } catch (error) {
      console.log(error);
    }
  };

  const getorders = async () => {
    const items = await getPurchaseRequisitionListReq()
  }

  const getPrFavoritesList = async () => {
    try {
      const response = await getPrFavoritesListReq()

      const uniqueFavourites = Array.from(
        new Map(response.data.map(item => [item?.purchaseOrder?._id, item])).values()
      )

      setFavourites(uniqueFavourites)
    } catch (error) {
      console.error("Error fetching favourites:", error)
      setFavourites([])
    }
  }
  const onDateChange = (data) => {
    skipDateEffect.current = false;
    setDate(data);
  };

  useEffect(() => {
    getorders()
    getPrFavoritesList()
  }, [])

  const getPurchaseOrderListData = async () => {
    try {
      const response = await getPurchaseOrderListReq(
        {
          startDate: date.start,
          endDate: date.end
        }
      );

      if (!response || !response.data || !Array.isArray(response.data)) {
        console.error('Unexpected response format:', response);
        return;
      }
      const newData = response.data.map((order) => ({
        order_id: order._id,
        order_number: order.purchaseOrderNumber ? order.purchaseOrderNumber : '-',
        createdAt: formatDate(order.createdAt),

        total:order.grandTotal,

        order_status: order.POStatus || order.status,
        branch_name: order?.shipping?.branchName || '-',
        client_name:order.clientName||'-',
        sub_total:order.totalAmount
      }));
      if (userType === "admin") {
      const acceptedOrders = newData.filter(
      (item) => item.order_status === "accepted"
      );
      setRowData(acceptedOrders.slice(0, 5));
      } else {
      const notRejectedOrders = newData.filter(
      (item) => item.order_status !== "declined"
      );
      setRowData(notRejectedOrders.slice(0, 5));
      }
      } catch (error) {
      console.error('Error fetching purchase orders:', error);
    }
  };

  const getTopItemsByAmount = async () => {
    try {
      setTopItemsLoading(true);



      const body = {
        page: 1,
        limit: 1000000,
        sortOrder: 'desc',
        sortBy: 'grandTotal',
        clientId: user?.userType === 'client' ? user?.clientId : '',
        startDate: date.start,
        endDate: date.end,
      };

      const res = await getItemPOList(body);

      if (res?.success && Array.isArray(res.payload?.data)) {
        const sorted = [...res.payload.data].sort(
          (a, b) => Number(b.grandTotal || 0) - Number(a.grandTotal || 0)
        );
        setTopItems(sorted.slice(0, 5));
      } else {
        setTopItems([]);
      }
    } catch (error) {
      console.error('Error fetching top items:', error);
      setTopItems([]);
    } finally {
      setTopItemsLoading(false);
    }
  };

  const handleCopyOrder = async (id) => {
    try {
      navigate(`/purchase-requisitions/${id}/copy`);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    props.setBreadcrumbItems('Dashboard', breadcrumbItems);
    searchClient(user.clientId);
  }, [user.clientId]);
  useEffect(() => {
    getPurchaseOrderListData();
    getPurchaseOrderStatusList();
    getTopItemsByAmount();
  }, [user.clientId, date]);

  return (
    <React.Fragment>
      <div className="m-4">
        <DateFilter
          onDateChange={onDateChange}
          initialValue={defaultDateRange.current}
        />
      </div>

      <Row className="g-4 align-items-stretch">

        <Col xl="7" lg="7" md="12" className="d-flex">
          <div style={{ flex: 1, display: "flex" }}>
            <Miniwidget reports={chipData} style={{ flex: 1, height: "auto" }} />
          </div>
        </Col>

        <Col xl="5" lg="5" md="12" className="d-flex">
          <Card style={{ flex: 1, height: "auto" }}>
            <CardBody className="h-100 d-flex flex-column">
              <h5 className="mb-3">Top 5 Items</h5>

              {
                topItemsLoading ? (
                  <div>Loading...</div>
                ) : topItems.length === 0 ? (
                  <div>No data available</div>
                ) : (
                  <table className="top-items-table w-100">
                    <tbody>
                      {topItems.map((item) => (
                        <tr key={item.itemId}>
                          <td>{item.itemName || "-"}</td>
                          <td style={{ textAlign: "right" }}>
                            <AmountCell value={item.grandTotal} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )
              }
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col xl="12">
          <Card>
            <CardBody>
              <OrderGraph />
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Row className="g-4 align-items-stretch">

        <Col xl="6" md="12" className="d-flex">
          <Card className="w-100 h-100">
            <CardBody className="d-flex flex-column h-100">
              <h4 className="mb-4">Recent Orders</h4>

              {rowData.length === 0 ? (
                <div>No recent orders</div>
              ) : (
                <div style={{ overflowX: "auto" }}>
                  <table className="w-100" style={{ minWidth: "700px" }}>

                    {/* HEADER */}
                    <thead >
                      <tr style={{ fontSize: "13px", color: "#6B6B6B",padding:"20px" ,textAlign:"center"}}>
                        <th>Order</th>
                        <th>Branch</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Customer Name</th>
                        <th>Sub Total</th>
                        <th>Amount</th>
                      </tr>
                    </thead>

                    {/* BODY */}
                  <tbody>
  {rowData
    .filter(
      (item) =>
        userType !== "admin" || item.order_status === "accepted"
    )
    .map((item) => (
      <tr
        key={item.order_id}
        style={{
          borderTop: "1px solid #eee",
          cursor: "pointer",
          textAlign: "center",
        }}
        onClick={() =>
          navigate(`/purchase-orders/${item.order_id}`)
        }
      >
        <td style={{ fontWeight: 500, padding: "10px 0" }}>
          {item.order_number}
        </td>

        <td style={{ padding: "10px 10px" }}>
          {item.branch_name}
        </td>

        <td style={{ padding: "10px 10px" }}>
          {item.createdAt}
        </td>

        <td style={{ padding: "10px 10px" }}>
          <OrderStatusRenderer value={item.order_status} />
        </td>

        <td style={{ padding: "10px 10px" }}>
          {item.client_name}
        </td>

        <td style={{ padding: "10px 10px" }}>
          <AmountCell value={item.sub_total}/>
        </td>

        <td style={{ padding: "10px 10px" }}>
          <AmountCell value={item.total} />
        </td>
      </tr>
    ))}
</tbody>
                  </table>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
        {userType!=="admin"?(
          
        <Col xl="6" md="12" className="d-flex" style={{height:"50vh"}} >
          <Card className="w-100 h-100 overflow-y-scroll">
            <CardBody className="d-flex flex-column h-100">
              <h4 className="mb-3">Favourite Orders</h4>

              {favourites.length === 0 ? (
                <div>No favourite orders yet</div>
              ) : (
                <table className="top-items-table w-100">
                  <thead>
                    <tr style={{ fontSize: "14px", color: "#000" }}>
                      <th style={{ textAlign: "left", paddingBottom: "8px" }}>
                        PR No.
                      </th>
                      <th style={{ textAlign: "center", paddingBottom: "8px" }}>
                        Total Amount
                      </th>
                      <th style={{ textAlign: "right", paddingBottom: "8px" }}>
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {favourites.map((item) => (
                      <tr key={item.id} style={{ cursor: "default" }}>
                        <td
                          onClick={() => handleCopyOrder(item?.purchaseOrder?._id)}
                          style={{ cursor: "pointer", color: "#0d6efd", textDecoration: "underline" }}
                        >
                          {item?.purchaseOrder?.purchaseRequisitionNumber || "--"}
                        </td>

                        <td style={{ textAlign: "center" }}>
                          <AmountCell value={item?.purchaseOrder?.grandTotal} />
                        </td>

                        <td style={{ textAlign: "right", position: "relative" }}>
                          <div
                            onClick={() => toggleOptionsMenu(item?.purchaseOrder?._id)}
                            style={{ cursor: "pointer", display: "inline-block" }}
                          >
                            <MoreVert />
                          </div>

                          {openMenuId === item?.purchaseOrder?._id && (
                            <>
                              <div
                                className="menu-backdrop"
                                onClick={() => toggleOptionsMenu(null)}
                              />

                              <div className="options-menu">
                                <div
                                  className="options-menu-item"
                                  onClick={() => handleCopyOrder(item?.purchaseOrder?._id)}
                                >
                                  Copy
                                </div>
                                <div
                                  className="options-menu-item delete"
                                  onClick={() => handleDeleteFromFavorites(item?.purchaseOrder?._id)}
                                >
                                  Delete
                                </div>
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </CardBody>
          </Card>
        </Col>
        ):null}

      </Row>

    </React.Fragment>
  );
}

export default connect(null, { setBreadcrumbItems })(Dashboard);
